import type { I18nOptions } from 'vue-i18n';

export default defineI18nConfig<I18nOptions>(() => ({
  warnHtmlInMessage: 'off',
  warnHtmlMessage: false,
}));
